import React from 'react'
import Pagination from '@material-ui/lab/Pagination';
import { createMuiTheme , ThemeProvider} from '@material-ui/core';

const darkTheme = createMuiTheme({
  palette:{
  type : "dark",
  }
})

const CustomPagination = ({ setPage , numofPages = 10}) => {

  const handlePageChange = (page)=>{
    setPage(page);
    window.scroll(0,0); 
  }

  return (
    <>
    <div style = {{
      color : "white",
      width : "100%",
      display : "flex",
      justifyContent : "center",
      marginTop : 10,
    }}>
      <ThemeProvider theme = {darkTheme}>
      <Pagination 
      count = {numofPages}
      onChange  = {(e)=> handlePageChange(e.target.textContent)}
      hideNextButton
      hidePrevButton
      color = "secondary"
      />
      </ThemeProvider>
    </div>
    </>
  )
}

export default CustomPagination
